/**
 * This file was copied from dashboard into clowncar as part of a cleanup effort
 */
import { SharedAppConstants } from '@tock/shared-app-constants';

/**
 * Fetch all features.
 * @returns {Object} A redux TockApi action.
 */
export function fetchAll(): ApiAction {
  return {
    TockApi: {
      getListProto: '/business/features',
      type: SharedAppConstants.FEATURES_FETCH_ALL,
    },
  };
}

export function fetchGlobalFeatures(): ApiAction {
  return {
    TockApi: {
      getListProto: '/features',
      type: SharedAppConstants.FEATURES_FETCH_GLOBAL,
    },
  };
}
